// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_e9-0";
export var actionModalContentContainer = "_e9-1";
export var createTagButton = "_e9-2";
export var footerContainer = "_e9-7";
export var fullWidthDivider = "_e9-3";
export var hasCreateTagButton = "_e9-4";
export var noCreateTagButton = "_e9-5";
export var tagsContainer = "_e9-6";
export var tagsModalContentContainer = "_e9-8";